import React from "react";
import AboutPromiseContainer from "@/containers/Content/AboutPromiseContainer";
export default function AboutPromise() {
  return <AboutPromiseContainer />;
}
